import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { translate } from "ra-core";

export const ExpandRowButton = ({
  classes,
  expanded,
  expandContentId,
  translate,
  ...props
}) => {
  return (
    <IconButton
      aria-label={translate(expanded ? "ra.action.close" : "ra.action.expand")}
      aria-expanded={expanded}
      aria-controls={expandContentId}
      className={classNames(classes.expandIcon, {
        [classes.expanded]: expanded,
      })}
      component="div"
      tabIndex={-1}
      aria-hidden="true"
      {...props}
    >
      <ExpandMoreIcon />
    </IconButton>
  );
};

ExpandRowButton.propTypes = {
  classes: PropTypes.any,
  expanded: PropTypes.bool,
  expandContentId: PropTypes.string,
  translate: PropTypes.func,
  locale: PropTypes.string,
};

export default translate(ExpandRowButton);
